import { Box } from '@mui/material';
import React from 'react';

import type { SxProps } from '../../../themes/themes';
import { getStyles } from './TabPanel.styles';

interface TabPanelProps {
  value: number;
  index: number;
  sx: SxProps;
}

export const TabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = ({
  value,
  index,
  children,
  sx,
  ...props
}) => {
  const styles = getStyles();
  return (
    <Box data-testid={`tab-panel-${index}`} hidden={value !== index} {...props}>
      <Box sx={{ ...sx, ...styles.inner }}>{children}</Box>
    </Box>
  );
};
